import { User } from "../../business-objects/user/user.model";

export interface IJobAssigneePickerModelArgs {
    items: Array<JobAssigneePickerItemModel>;
}

export interface IJobAssigneePickerItemModelArgs {
    user: User;
}

export class JobAssigneePickerModel {
    protected _items: Array<JobAssigneePickerItemModel>;

    constructor(args: IJobAssigneePickerModelArgs) {
        Object.keys(args).forEach(key => {
            this[`_${key}`] = args[key];
        });
    }

    get items(): Array<JobAssigneePickerItemModel> {
        return this._items;
    }
}

export class JobAssigneePickerItemModel {
    protected user: User;

    constructor(args: IJobAssigneePickerItemModelArgs) {
        Object.keys(args).forEach(key => {
            this[key] = args[key];
        });
    }

    get id(): string {
        return this.user.id;
    }

    get label(): string {
        return `${this.user.name}` ;
    }
}



// WEBPACK FOOTER //
// ./src/vas/modules-shared/job-assignee-picker/job-assignee-picker.model.ts